import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import {
  Box,
  Button,
  ButtonBase,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@material-ui/core';

import { ReactComponent as OkIcon } from '../../../../assets/img/icon/Ok.svg';
import SubHeader from '../../../../components/Header/SubHeader.component';
import Loader from '../../../../components/LoaderSplash/Loader.component';
import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { useVehiclesContext } from '../../../../context/vehicles/vehicles.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';
import { getFormattedDate } from '../../../../helpers/getDate';
import { getAccesories } from '../../../../services/policy/policy.service';
import SendEmail from '../Components/SendEmail.component';

const CertificateOfCoverage = () => {
  const { loading, vehicle, policy, getPolicyById } = useVehiclesContext();
  const { id }: any = useParams();
  const history = useHistory();
  const { user } = useAuthDataContext();
  const [dialog, setDialog] = useState(false);
  const [details, setDetails] = useState([]);
  const [loadingHelper, setLoaderhelper] = useState(false);
  const { state } = useLocation<any>();

  useEffect(() => {
    dataLayerPush('Documentacion_certificado_cobertura', user?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (id) {
      if (policy.id !== Number(id)) {
        getPolicyById(id);
      }
    } else {
      history.goBack();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const TO_SHOW = [
    {
      title: 'Tipo de cobertura',
      content: vehicle.coverage,
    },
    {
      title: 'Vigencia',
      content: `del ${getFormattedDate(policy.starts_at)} al ${getFormattedDate(
        policy.expires_at
      )}`,
    },
    {
      title: 'Tipo de Asistencia',
      content: vehicle.assistance_name,
    },
    {
      title: 'Suma asegurada',
      content:
        '$ ' + (vehicle.insured_amount ? vehicle.insured_amount : '0.00'),
    },
  ];

  const getDetails = async () => {
    setLoaderhelper(true);
    try {
      //  fix me: PASAR AL CONTEXT Y AL REDUCER
      const accessoriesData = await getAccesories(state.vehicle_id);
      setDetails(accessoriesData.data);
      setLoaderhelper(false);
    } catch (error) {
      setDialog(true);
      setLoaderhelper(false);
    }
  };

  return Object.keys(policy).length ? (
    <>
      <SharedDialog
        open={dialog}
        onClose={() => setDialog(false)}
        content={
          <Box>
            <Typography variant="h6">¡Ups, ha ocurrido un error!</Typography>
            <Box my={2}>
              <Typography>
                Hubo un error al solicitar los datos de la cobertura, espere un
                mometno e intente nuevamente.
              </Typography>
            </Box>
          </Box>
        }
        actions={
          <Grid container justify="flex-end">
            <Grid item xs={12}>
              <Box m={2}>
                <Button
                  variant="outlined"
                  color="secondary"
                  fullWidth
                  onClick={() => setDialog(false)}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>

      <Box display={loading || loadingHelper ? 'block' : 'none'}>
        <Loader
          action={
            loadingHelper
              ? 'Cargando el detalle de la cobertura'
              : 'Cargando póliza'
          }
        ></Loader>
      </Box>

      <SubHeader
        content={
          <>
            <Typography>Certificado de cobertura</Typography>
            <Typography variant="h6" color="primary">
              {vehicle.brand +
                ' ' +
                vehicle.model.split(' ')[0] +
                ' ' +
                vehicle.year +
                ' / ' +
                vehicle.license_plate}
            </Typography>{' '}
            <Typography variant="caption">
              Es un documento que constata que tenés la cobertura.
            </Typography>
          </>
        }
        actions={
          <SendEmail documentType={'certificate_of_coverage'}></SendEmail>
        }
      ></SubHeader>

      <Grid container justify="center">
        <Grid item xs={11} sm={10} lg={8}>
          {/* VEHCILE INFO */}
          <Grid container>
            {TO_SHOW.map((item: any, index: number) => (
              <Grid item xs={12} sm={6} key={index}>
                <Box my={2}>
                  <Typography variant="caption">{item.title}</Typography>
                </Box>
                <Box>
                  <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                    {item.content}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>

          <Grid container>
            <Grid item xs={12}>
              <Box my={2}>
                <ButtonBase
                  disabled={details.length > 0 ? true : false}
                  onClick={getDetails}
                >
                  <Typography variant="body2" color="secondary">
                    Ver detalle de cobertura
                  </Typography>
                </ButtonBase>
              </Box>
              <List aria-label="detalles">
                {details &&
                  details.map((accesory: any, index: number) => (
                    <ListItem key={index}>
                      <ListItemIcon>
                        <OkIcon />
                      </ListItemIcon>
                      <ListItemText
                        disableTypography
                        primary={
                          <Typography variant="body2">{accesory}</Typography>
                        }
                      />
                    </ListItem>
                  ))}
              </List>
              {/* {details.length > 4 ? (
                <Box display="flex" justifyContent="flex-end">
                  {!showMore ? (
                    <Button onClick={() => setShowMore(true)} color="secondary">
                      + Ver más
                    </Button>
                  ) : (
                    <Button
                      color="secondary"
                      onClick={() => setShowMore(false)}
                    >
                      - Ver menos
                    </Button>
                  )}
                </Box>
              ) : null} */}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  ) : null;
};

export default CertificateOfCoverage;
